import * as React from 'react';
import { Redirect } from 'react-router';
import {
	App,
	UserProfile,
	ShopCard,
	UserCard,
	ManageArticle,
	ArticleCard,
	AdminArticles,
	ViewMagazinePage,
	MagazineHome,
	ArticleTags,
	MagazineArticleSearchResults,
	ViewPortalPage,
	AdminPolls,
	DeactivateUserFinished,
	CreateShop,
	CreateShopPresentation,
	ManageUserShippingAddress,
	UserShippingAddresses,
	ShopProducts,
	ShopOrders,
	ManageShopGeneral,
	ManageShopShipping,
	ManageShopAddress,
	UserOrders,
	UserOrderCard,
	ShopOrderCard,
	Callback,
	CallbackSilent,
	LogoutCallback,
	privateRoute,
	privatePermissionRoute,
	CartThankYou,
	ErrorPage404,
	ErrorPage500,
	PortalCookiePolicyEN,
	PortalCookiePolicyIT,
	PortalPrivacyPolicyEN,
	PortalPrivacyPolicyIT,
	PortalPrivacyPolicySL,
	PortalTermsOfUseEN,
	PortalTermsOfUseIT,
	PortalTermsOfUseHR,
	PortalTermsOfUseSL,
	PortalDeleteAccountEN,
	PortalDeleteAccountHR,
	PortalDeleteAccountIT,
	PortalDeleteAccountSL,
	AdminShopReviews,
	NotificationSettings,
	NotificationsPage,
	ManageMenuItem,
	MenuItems,
	MenuEditor,
	AdminShops,
	SalonsPage,
	LandingPage,
	AdminSubscriptionPlans,
	AdminNewSubscriptionPlan,
	ManageShopLocations,
	ShopAppointments,
	OfficeWorkTime,
	AdminServerLog,
	SalesPromotions,
	AdminEditShopSubscriptionPlans,
} from 'containers';
import { EmailConfirmedMessage, Register, RedirectOnLoad, Error } from 'components';
import {
	PortalBaseLayout,
	MagazineBaseLayout,
	MagazinePageLayout,
	AdministrationBaseLayout,
} from 'components/PortalStructure';
import ExtendedRoute, { ExtendedIndexRoute } from 'routes/extendedroute';
import { ManageShopMembers } from 'containers/Shop/ManageShop/Settings/Members';
import { UserAccount } from 'containers/User/UserAccount';
import ShopServices from 'containers/Shop/ShopServices';
import ShopBundlesServicesAddEdit from 'containers/Shop/ShopBundlesServicesAddEdit';
import ShopInfo from 'containers/Shop/ShopInfo';
import { BookAppointment } from 'containers/BookAppointment';
import { ShopCustomerList } from 'containers/Shop/ShopCustomerList';
import ShopInfoAnalytics from 'containers/Shop/ShopInfoAnalytics';
import { ShopCustomer } from 'containers/Shop/ShopCustomer';
import ShopServicesSingleAddEdit from 'containers/Shop/ShopBundlesServicesAddEdit/ShopServicesSingleAddEdit';
import ShopBundlesAddEdit from 'containers/Shop/ShopBundlesServicesAddEdit/ShopBundlesAddEdit';
import { NewPromotion } from 'containers/Shop/NewPromotion';
import { ViewPromotion } from 'containers/Shop/ViewPromotion';
import { detectIncompatibleBrowsers } from 'helpers/common';

export default (
	<ExtendedRoute
		component={App}
		breadcrumbIgnore={true}
		onChange={() => {
			setTimeout(() => {
				if (detectIncompatibleBrowsers()) {
					document.body.scrollTo({ top: 0, left: 0 });
				} else {
					window.scrollTo({ top: 0, left: 0 });
				}
			}, 100);
		}}
	>
		<Redirect from="/loginfinished" to="/" />
		<Redirect from="/ico" to="/tokensales" />

		<ExtendedRoute path="/signin-oidc" component={Callback} />
		<ExtendedRoute path="/silentrenew" component={CallbackSilent} />
		<ExtendedRoute path="/logout/callback" component={LogoutCallback} />

		{/* Admin Routes */}
		<Redirect from="/admin" to="admin/portal/pages/all" />
		<Redirect from="/admin/articles" to="/admin/articles/allposts" />
		<Redirect from="/admin/portal" to="/admin/portal/pages/all" />
		<Redirect from="/admin/portal/pages" to="/admin/portal/pages/all" />
		<Redirect from="/admin/magazine" to="admin/magazine/pages/all" />
		<Redirect from="/admin/magazine/pages" to="admin/magazine/pages/all" />
		<ExtendedRoute
			path="admin"
			component={privateRoute(AdministrationBaseLayout)}
			breadcrumbName="Admin_Breadcrumb_Admin"
		>
			<ExtendedRoute path="portal" breadcrumbName="BSPortal_Common_Portal">
				<ExtendedRoute path="pages" breadcrumbName="BSPortal_Common_Pages">
					<ExtendedRoute path="all" component={MenuItems} breadcrumbName="BSPortal_Common_All" />
					<ExtendedRoute path="active" component={MenuItems} breadcrumbName="BSPortal_Common_Active" />
					<ExtendedRoute path="expired" component={MenuItems} breadcrumbName="BSPortal_Common_Expired" />
					<ExtendedRoute path="edit(/:id)" component={ManageMenuItem} breadcrumbName="BSPortal_Common_Edit" />
					<ExtendedRoute path="new" component={ManageMenuItem} breadcrumbName="BSPortal_Common_Create" />
				</ExtendedRoute>
				<ExtendedRoute path="menu" component={MenuEditor} breadcrumbName="BSPortal_Common_MenuEditor" />
			</ExtendedRoute>

			<ExtendedRoute path="magazine" breadcrumbName="BSPortal_Common_Magazine">
				<ExtendedRoute path="pages" breadcrumbName="BSPortal_Common_Pages">
					<ExtendedRoute path="all" component={MenuItems} breadcrumbName="BSPortal_Common_All" />
					<ExtendedRoute path="active" component={MenuItems} breadcrumbName="BSPortal_Common_Active" />
					<ExtendedRoute path="expired" component={MenuItems} breadcrumbName="BSPortal_Common_Expired" />
					<ExtendedRoute path="edit(/:id)" component={ManageMenuItem} breadcrumbName="BSPortal_Common_Edit" />
					<ExtendedRoute path="new" component={ManageMenuItem} breadcrumbName="BSPortal_Common_Create" />
				</ExtendedRoute>
				<ExtendedRoute path="menu" component={MenuEditor} breadcrumbName="BSPortal_Common_MenuEditor" />
			</ExtendedRoute>

			<ExtendedRoute path="articles" breadcrumbName="Admin_Breadcrumb_Articles">
				<ExtendedRoute path="allposts" component={AdminArticles} breadcrumbName="Admin_Breadcrumb_Articles_AllPosts" />
				<ExtendedRoute path="approved" component={AdminArticles} breadcrumbName="Admin_Breadcrumb_Articles_Approved" />
				<ExtendedRoute path="pending" component={AdminArticles} breadcrumbName="Admin_Breadcrumb_Articles_Pending" />
				<ExtendedRoute path="drafts" component={AdminArticles} breadcrumbName="Admin_Breadcrumb_Articles_Drafts" />
				<ExtendedRoute path="unlisted" component={AdminArticles} breadcrumbName="Admin_Breadcrumb_Articles_Unlisted" />
				<ExtendedRoute
					path="managearticle(/:id)"
					component={ManageArticle}
					breadcrumbName="Admin_Breadcrumb_Articles_ManageArticle"
				/>
				<ExtendedRoute path="newarticle" to="/admin/articles/managearticle" component={RedirectOnLoad} />
			</ExtendedRoute>

			<ExtendedRoute path="shops" breadcrumbName="Admin_Breadcrumb_Shops">
				<ExtendedRoute path="allshops" component={AdminShops} breadcrumbName="Admin_Breadcrumb_Shops_AllShops" />
				<ExtendedRoute path="approved" component={AdminShops} breadcrumbName="Admin_Breadcrumb_Shops_Approved" />
				<ExtendedRoute path="pending" component={AdminShops} breadcrumbName="Admin_Breadcrumb_Shops_Pending" />
			</ExtendedRoute>

			<ExtendedRoute path="tags" component={ArticleTags} breadcrumbName="Admin_Breadcrumb_Tags" />
			<ExtendedRoute path="polls" component={AdminPolls} breadcrumbName="Admin_Breadcrumb_Polls" />
			<ExtendedRoute path="shopreviews" component={AdminShopReviews} breadcrumbName="Admin_Breadcrumb_ShopReviews" />
			<ExtendedRoute
				path="subscriptionplans"
				component={AdminSubscriptionPlans}
				breadcrumbName="Admin_Breadcrumb_SubscriptionPlans"
			/>
			<ExtendedRoute
				path="subscriptionplans/edit(/:id)"
				component={AdminNewSubscriptionPlan}
				breadcrumbName="Admin_Breadcrumb_SubscriptionPlans"
			/>
			<ExtendedRoute
				path="subscriptionplans/shop(/:shopId)"
				component={AdminEditShopSubscriptionPlans}
				breadcrumbName="Admin_Breadcrumb_ShopSubscriptionPlans"
			/>
			<ExtendedRoute path="serverlog" component={AdminServerLog} breadcrumbName="Server Log" />
		</ExtendedRoute>
		{/* Admin Routes */}

		{/* Magazine Routes */}
		<ExtendedRoute path="/magazine/404" component={ErrorPage404} />
		<ExtendedRoute path="/magazine/500" component={ErrorPage500} />
		<ExtendedRoute path="magazine" component={MagazineBaseLayout}>
			<ExtendedRoute component={MagazinePageLayout}>
				<ExtendedRoute path="page/:code" component={ViewMagazinePage} darkHeader />
				<ExtendedRoute path="page/:code/tag/:keyword" component={ViewMagazinePage} />
				<ExtendedRoute path="search/:keyword" component={MagazineArticleSearchResults} />
				<ExtendedRoute path="search/tag/:keyword" component={MagazineArticleSearchResults} />
				<ExtendedRoute path="search/author/:id" component={MagazineArticleSearchResults} />
				<ExtendedRoute path="article/:code" component={ArticleCard} darkHeader />
				<ExtendedRoute path=":culture" component={MagazineHome} />
			</ExtendedRoute>
		</ExtendedRoute>
		{/* Magazine Routes */}

		{/* Portal Routes */}
		<Redirect from="/home" to="/" />
		<Redirect from="/home/:culture" to="/" />
		<Redirect from="/shop/:id/edit" to="shop/:id/edit/dashboard" />
		<ExtendedRoute path="/404" component={ErrorPage404} darkHeader />
		<ExtendedRoute path="/500" component={ErrorPage500} darkHeader />
		<ExtendedRoute path="/error" component={Error} />
		<ExtendedRoute path="/" component={PortalBaseLayout}>
			<ExtendedIndexRoute component={LandingPage} landingPageHeader darkFooter />
			<ExtendedRoute path="deactivateuser" component={DeactivateUserFinished} />

			{/* one column */}
			<ExtendedRoute path="salons" component={SalonsPage} darkHeader />
			<ExtendedRoute path="home/:culture" component={ViewPortalPage} />
			<ExtendedRoute path="portal/page/:code" component={ViewPortalPage} darkHeader />
			<ExtendedRoute path="emailconfirmed" component={EmailConfirmedMessage} />
			<ExtendedRoute path="register" component={Register} />
			{/* <ExtendedRoute path="search(/:keyword)" component={SearchResults} /> */}
			<ExtendedRoute path="profile/:code(/:shopId)" component={UserCard} />
			<ExtendedRoute path="cookiepolicy/en" component={PortalCookiePolicyEN} darkHeader />
			<ExtendedRoute path="cookiepolicy/it" component={PortalCookiePolicyIT} darkHeader />
			<ExtendedRoute path="privacypolicy/en" component={PortalPrivacyPolicyEN} darkHeader />
			<ExtendedRoute path="privacypolicy/it" component={PortalPrivacyPolicyIT} darkHeader />
			<ExtendedRoute path="privacypolicy/sl" component={PortalPrivacyPolicySL} darkHeader />
			<ExtendedRoute path="termsofuse/en" component={PortalTermsOfUseEN} darkHeader />
			<ExtendedRoute path="termsofuse/it" component={PortalTermsOfUseIT} darkHeader />
			<ExtendedRoute path="termsofuse/hr" component={PortalTermsOfUseHR} darkHeader />
			<ExtendedRoute path="termsofuse/sl" component={PortalTermsOfUseSL} darkHeader />
			<ExtendedRoute path="deleteaccount/en" component={PortalDeleteAccountEN} darkHeader />
			<ExtendedRoute path="deleteaccount/it" component={PortalDeleteAccountIT} darkHeader />
			<ExtendedRoute path="deleteaccount/hr" component={PortalDeleteAccountHR} darkHeader />
			<ExtendedRoute path="deleteaccount/sl" component={PortalDeleteAccountSL} darkHeader />
			{/* <ExtendedRoute path="deliveryandreturns/en" component={PortalDeliveryAndReturnsEN} /> */}
			{/* <ExtendedRoute path="deliveryandreturns/it" component={PortalDeliveryAndReturnsIT} /> */}
			{/* <ExtendedRoute path="paymentoptions/en" component={PortalPaymentOptionsEN} /> */}
			{/* <ExtendedRoute path="paymentoptions/it" component={PortalPaymentOptionsIT} /> */}

			{/* two columns */}
			<ExtendedRoute path="userprofile" component={privateRoute(UserProfile)} />
			<ExtendedRoute path="account" component={privateRoute(UserAccount)} />
			{/* <ExtendedRoute path="payment" component={privateRoute(UserPaymentMethods)} /> */}
			<ExtendedRoute path="notification-settings" component={privateRoute(NotificationSettings)} />
			{/* <ExtendedRoute path="userpreferences" component={privateRoute(UserPreferences)} /> */}
			{/* <ExtendedRoute path="usershops" component={privateRoute(UserShops)} /> */}
			{/* <ExtendedRoute path="wallet" component={privateRoute(Wallet)} /> */}
			<ExtendedRoute path="userorders" component={privateRoute(UserOrders)} />
			<ExtendedRoute path="userorder(/:id)" component={privateRoute(UserOrderCard)} />
			<ExtendedRoute path="notifications" component={privateRoute(NotificationsPage)} />

			{/* <ExtendedRoute path="startashop" component={StartAShop} /> */}
			<ExtendedRoute path="shop" to="/forbusiness" component={RedirectOnLoad} />
			<ExtendedRoute path="forbusiness" component={CreateShopPresentation} darkHeader darkFooter noHeader />
			<ExtendedRoute path="features" component={CreateShopPresentation} darkHeader darkFooter noHeader />
			<ExtendedRoute path="shop/create" to="/salon/create" component={RedirectOnLoad} />
			<ExtendedRoute path="salon/create" component={privateRoute(CreateShop)} darkHeader />
			<ExtendedRoute
				path="shop/:id/appointments(/:officeId)"
				component={privatePermissionRoute(ShopAppointments, 'Member')}
				darkHeader
				noFooter
			/>
			<ExtendedRoute
				path="shop/:id/worktime(/:officeId)"
				component={privatePermissionRoute(OfficeWorkTime, 'Member')}
				darkHeader
				noFooter
			/>
			<ExtendedRoute path="shop/:code(/:officeId)" component={ShopCard} />
			<ExtendedRoute
				path="myShop/:code(/:officeId)"
				component={(props) => <ShopCard {...{ ...props, baseUrl: 'myShop' }} />}
				restrictedMode
			/>
			<ExtendedRoute
				path="shop/:shopId/:officeId/choose-service"
				component={privatePermissionRoute(ShopBundlesServicesAddEdit)}
			/>
			<ExtendedRoute
				path="shop/:shopId/:officeId/edit/services/add"
				component={privatePermissionRoute(ShopServicesSingleAddEdit)}
				mode="add"
			/>
			<ExtendedRoute
				path="shop/:shopId/:officeId/edit/bundle/add"
				component={privatePermissionRoute(ShopBundlesAddEdit)}
				mode="add"
			/>
			<ExtendedRoute
				path="shop/:shopId/:officeId/edit/services(/:serviceCategory)"
				component={privatePermissionRoute(ShopServices)}
			/>
			<ExtendedRoute
				path="shop/:shopId/:officeId/edit/services/editexisting/:serviceId"
				component={privatePermissionRoute(ShopServicesSingleAddEdit)}
				mode="edit"
			/>
			<ExtendedRoute
				path="shop/:shopId/:officeId/edit/services/existing/:variantParentId/:serviceGroupId"
				component={privatePermissionRoute(ShopServicesSingleAddEdit)}
				mode="edit"
			/>
			<ExtendedRoute
				path="shop/:shopId/:officeId/edit/bundle/editexisting/:serviceId"
				component={privatePermissionRoute(ShopBundlesAddEdit)}
				mode="edit"
			/>
			<ExtendedRoute
				path="shop/:shopId/:officeId/edit/bundle/existing/:variantParentId/:serviceGroupId"
				component={privatePermissionRoute(ShopBundlesAddEdit)}
				mode="edit"
			/>
			<ExtendedRoute path="shop/:shopId/edit/services" component={privatePermissionRoute(ShopServices)} />
			<ExtendedRoute path="shop/:shopId/edit/promo" component={privatePermissionRoute(SalesPromotions)} />
			{/*<ExtendedRoute path="shop/:shopId/edit/promo/new" component={privatePermissionRoute(NewPromotion)} />*/}
			<ExtendedRoute path="shop/:shopId/new/promo/:promotionType" component={privatePermissionRoute(NewPromotion)} />
			<ExtendedRoute
				path="shop/:shopId/view/promo/:promotionGroupId"
				component={privatePermissionRoute(ViewPromotion)}
			/>
			<ExtendedRoute
				path="shop/:shopId/:mode/promo/:promotionGroupId"
				component={privatePermissionRoute(NewPromotion)}
			/>
			<ExtendedRoute path="shop/:id/edit/" component={privatePermissionRoute(ShopInfo, 'Member')}>
				<ExtendedRoute path="customers" component={ShopCustomerList} />
				<ExtendedRoute path="products" component={privatePermissionRoute(ShopProducts)} />
				<ExtendedRoute path="orders" component={privatePermissionRoute(ShopOrders)} />
				<ExtendedRoute path="analytics(/:officeId)" component={privatePermissionRoute(ShopInfoAnalytics)} />
			</ExtendedRoute>
			<ExtendedRoute path="shop/:id/customer/:customerId" component={privateRoute(ShopCustomer)} />
			<ExtendedRoute path="shop/:id/edit/general" component={privatePermissionRoute(ManageShopGeneral)} />
			<ExtendedRoute path="shop/:id/edit/shipping" component={privateRoute(ManageShopShipping)} />
			<ExtendedRoute path="shop/:id/edit/address" component={privateRoute(ManageShopAddress)} />
			<ExtendedRoute path="shop/:id/edit/orders/order/:shopOrderId" component={privateRoute(ShopOrderCard)} />

			{/* <ExtendedRoute
				path="shop/:id/edit/shipping/shippingoptions/create"
				component={privateRoute(ManageShopShippingOption)}
			/> */}
			{/* <ExtendedRoute
				path="shop/:id/edit/shipping/shippingoptions/:shippingOptionId/edit"
				component={privateRoute(ManageShopShippingOption)}
			/> */}

			{/* <ExtendedRoute path="shop/:id/edit/dashboard" component={privateRoute(ShopDashboard)} /> */}
			{/* <ExtendedRoute path="shop/:id/edit/discounts" component={privateRoute(ShopDiscounts)} /> */}
			{/* <ExtendedRoute path="shop/:id/edit/funds" component={privateRoute(ShopFunds)} /> */}
			{/* <ExtendedRoute path="shop/:id/edit/insights" component={privateRoute(ShopInsights)} /> */}
			{/* <ExtendedRoute path="shop/:id/edit/messages" component={privateRoute(ShopMessages)} /> */}
			<ExtendedRoute path="shop/:id/edit/locations" component={privatePermissionRoute(ManageShopLocations)} />
			<ExtendedRoute path="shop/:id/edit/members" component={privatePermissionRoute(ManageShopMembers)} />

			{/* <ExtendedRoute path="shop/:id/edit/products/create" component={privateRoute(EditProduct)} darkHeader /> */}
			{/* <ExtendedRoute
				path="shop/:id/edit/products/:variantParentId/edit"
				component={privateRoute(EditProduct)}
				darkHeader
			/> */}

			{/* <ExtendedRoute path="shop/:id/edit/products/import" component={privateRoute(ImportProducts)} /> */}
			{/* <ExtendedRoute path="shop/:id/edit/products/import/images" component={privateRoute(ProductsImportImages)} /> */}

			<ExtendedRoute path="shop/:code(/:officeId)" component={ShopCard} />

			{/* <ExtendedRoute path="products/:code" component={ProductCard} /> */}

			<ExtendedRoute path="user/edit/shippingaddresses" component={privateRoute(UserShippingAddresses)} />
			<ExtendedRoute path="user/edit/shippingaddresses/create" component={privateRoute(ManageUserShippingAddress)} />
			<ExtendedRoute path="user/edit/shippingaddresses/:id/edit" component={privateRoute(ManageUserShippingAddress)} />

			<ExtendedRoute path="managearticle(/:id)" component={ManageArticle} darkHeader />
			{/* <ExtendedRoute path="newarticle" to="/managearticle" component={RedirectOnLoad} /> */}

			{/* <ExtendedRoute path="outfit/:id/edit" component={EditOutfit} /> */}
			{/* <ExtendedRoute path="outfits/:code" component={OutfitCard} />

			<ExtendedRoute path="wardrobeitems/:code" component={WardrobeItemCard} /> */}

			{/* <ExtendedRoute path="cart" component={Cart} /> */}
			<ExtendedRoute path="cartthankyou" component={CartThankYou} />

			<ExtendedRoute path="bookappointment/:shopId/:officeId" component={privateRoute(BookAppointment)} darkHeader />

			{/* <ExtendedRoute path="/sizeguide" component={SizeGuide} /> */}
		</ExtendedRoute>
		{/* Portal Routes */}

		{/* Main Routes */}
		<ExtendedRoute path="*" component={ErrorPage404} />
		{/* Main Routes */}
	</ExtendedRoute>
);
